<template>
    <div>
        <template v-if="error === null">
            Loading...
        </template>
        <template v-if="error === true">
            Error
        </template>
        <JobTypeSelectComponent
                ref="jobTypeSelectComponent"
                v-model="selectedJobType"
                v-bind:rootJobTypes="rootJobTypes">
        </JobTypeSelectComponent>
    </div>
</template>

<script>
    //import errorReportingClient from '../Common/error-reporting-client';
    import JobTypeSelectComponent from './JobTypeSelectComponent';
    import jobTypeApi from './JobTypeApi';

    export default {
    	name:"JobTypeSelectApp",
        data() {
            return {
                jobTypes: null,
                selectedJobType: null,
                error: null,
            };
        },
        methods: {

        },
        async created() {
            try {
                this.jobTypes = await jobTypeApi.fetchJobTypes();
                this.error = false;
            }
            catch (error) {
                this.error = true;
                errorReportingClient.notify(error);
            }
        },
        watch: {
			selectedJobType(value){
				if(value !== null){
					this.$emit('jobTypeSelected',value.id);
                }else{
					this.$emit('jobTypeSelected',null);
                }
			}
        },
        computed: {
            rootJobTypes() {
                if (this.jobTypes === null) {
                    return null;
                }
                return Object.values(this.jobTypes).filter(jobType => jobType.isRoot());
            },
            selectedLeafJobType() {
                if (this.selectedJobType === null) {
                    return null;
                }
                if (this.selectedJobType.isLeaf()) {
                    return this.selectedJobType;
                }
                return null;
            },
            selectedRootJobTypeId() {
                if (this.selectedJobType === null) {
                    return null;
                }
                return this.selectedJobType.getRoot().id;
            },
        },
        components: {
            JobTypeSelectComponent
        }
    }
</script>
